var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTopicon = function SvgTopicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.107 15.145h-.714a.357.357 0 0 1-.357-.357V3.234l-3.173 3.18a.357.357 0 0 1-.507 0l-.5-.507a.357.357 0 0 1 0-.508l4.38-4.387c.1-.1.236-.157.378-.157h.272a.55.55 0 0 1 .378.157l4.38 4.387a.357.357 0 0 1 0 .508l-.507.507a.35.35 0 0 1-.5 0l-3.173-3.18v11.554c0 .197-.16.357-.357.357Z"
  })));
};
export default SvgTopicon;